import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetFeatureFlagNotification = (options = {}) => {
  const query = useApiQuery(
    ['feature-flag-notification'],
    'schools',
    '/feature-flags/send_complaint_notifications',
    options,
    { authenticated: true, version: 5 }
  )

  return {
    isLoadingFeatureFlagNotification: query.isLoading,
    isFetchingFeatureFlagNotification: query.isFetching,
    featureFlagNotification: query.data ?? [],
    errorFeatureFlagNotification: query.isError ? query.error : null,
    getFeatureFlagNotification: query.refetch
  }
}
